export const textFieldInputParser = (value, dataType) => {
  const valueParsers = {
    0: (value) => value,
    1: (value) => value,
    2: (value) => value,
    3: (value) => parseInt(value),
    4: (value) => parseInt(value),
    7: (value) => value,
  };
  return (valueParsers[dataType] || ((value) => value))(value);
};
